import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_RESOURCE_CATEGORIES,
  FETCH_RESOURCE_CATEGORIES_SUCCESS,
  FETCH_RESOURCE_CATEGORIES_FAIL,
] = createRequestConstantNames(cc('FETCH_RESOURCE_CATEGORIES'));
